var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"location-container"},[_c('img',{staticClass:"preview-img mr-2",attrs:{"src":require("../../assets/location.svg")}}),_c('p',[_vm._v(_vm._s(_vm.locationName))])])}
var staticRenderFns = []

export { render, staticRenderFns }